// extracted by mini-css-extract-plugin
module.exports = {"subscriptions":"Subscriptions_subscriptions__ds2RN","subscriptions__title":"Subscriptions_subscriptions__title__6NLW8"};